import Container from 'react-bootstrap/Container'

import Typography from '../../components/Typography/Typography'
import ErrorWindow from '../../components/Windows/ErrorWindow/ErrorWindow'

import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import './Maintenance.scss'

const Maintenance = () => {
    const intl = useIntl()

    const MAINTENANCE = process.env.REACT_APP_MAINTENANCE

    useEffect(() => {
        if (MAINTENANCE === 'clearLocalStorage') {
            localStorage.clear()
        }
    }, [])

    const backToCinestarWeb = () => {
        let referer = localStorage.getItem('referer')
        if (!referer || referer === 'undefined') {
            referer = `https://${process.env.REACT_APP_WEB_PORTAL_URL}`
        }
        window.location.href = referer
    }
    return (
        <Container fluid className="page-500 d-flex flex-column align-items-center">
            <Typography variant={'h1'} className={'me-auto'}>
                {intl.formatMessage({ id: 'maintenance.pageTitle' })}
            </Typography>
            <ErrorWindow
                title={intl.formatMessage({ id: 'maintenance.title' })}
                description={intl.formatMessage({ id: 'maintenance.description' })}
                textButton1={intl.formatMessage({ id: 'maintenance.button' })}
                onClickButton1={() => backToCinestarWeb()}
            />
        </Container>
    )
}

export default Maintenance
